module.exports = __webpack_public_path__ + "img/pepperoni.b9b2ed99.jpg";